/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box } from 'chakra-v3';
import UserHeader from '../components/headers/UserHeader';
import { CardShell } from '../components/Index';
import { Text } from '../components/Text';
import { HelpDesktopMenu, HelpMobileMenu } from '../components/help/Index';

const WHATSAPP_WEB_URL = import.meta.env.VITE_WHATSAPP_WEB_URL;
const WHATSAPP_CHATBOT_URL = import.meta.env.VITE_WHATSAPP_CHATBOT_URL;

const Help: React.FC = () => {
  return (
    <Box minH="100vh" bg="bg.primary">
      <UserHeader />
      <Box
        minH="calc(100vh - 100px)"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        px={{ base: 4, md: 6, lg: 8 }}
        py={{ base: 8, md: 12, lg: 16 }}
      >
        <Text variant="heroHeading" mb={{ base: 8, md: 12, lg: 16 }}>
          Get help through our WhatsApp Chatbot
        </Text>
        <CardShell
          w={{ base: '100%', md: '90%', lg: '1024px' }}
          maxW="1024px"
          h={{ base: 'auto', lg: '540px' }}
          blurProps={{ minH: { base: '400px', lg: '540px' } }}
          contentProps={{
            h: { base: 'auto', lg: '540px' },
            px: { base: 0, md: 4 },
          }}
        >
          <HelpDesktopMenu whatsappChatbotUrl={WHATSAPP_CHATBOT_URL} whatsappWebUrl={WHATSAPP_WEB_URL} />
          <HelpMobileMenu whatsappChatbotUrl={WHATSAPP_CHATBOT_URL} whatsappWebUrl={WHATSAPP_WEB_URL} />
        </CardShell>
      </Box>
    </Box>
  );
};

export default Help;
